'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _path = require('path');

var _path2 = _interopRequireDefault(_path);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _iphoneInlineVideo = require('iphone-inline-video');

var _iphoneInlineVideo2 = _interopRequireDefault(_iphoneInlineVideo);

var _DateTime = require('lib/rtveLab/DateTime');

require('./comLabVideo.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var videoEvents = ['play', 'pause', 'playing', 'abort', 'progress', 'ratechange', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'ended', 'loadeddata', 'loadedmetadata', 'loadstart', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting', 'error', 'encrypted', 'mozaudioavailable', 'interruptbegin', 'interruptend'];
var ComLabVideo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ComLabVideo, _Component);

  function ComLabVideo(props) {
    (0, _classCallCheck3.default)(this, ComLabVideo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ComLabVideo.__proto__ || (0, _getPrototypeOf2.default)(ComLabVideo)).call(this, props));

    _this.state = {
      isPlaying: _this.props.autoPlay ? true : false,
      isMuted: true,
      isSubtitled: _this.props.isSubtitled ? true : false,
      currentTime: '00:00',
      duration: '00:00',
      loadedProgress: 0,
      seekProgress: 0, // how much has played
      volume: _this.props.volume || 1,
      activeSubtitle: _this.props.activeSubtitle === undefined ? null : _this.props.activeSubtitle,
      customSubtitlesShow: false,
      seekDisabled: _this.props.seekDisabled ? true : false,
      mobileStoped: true,
      reStart: false
    };

    //contadores
    _this.countPlay = 0;
    _this.count25 = 0;
    _this.count50 = 0;
    _this.count90 = 0;

    // Controls icons

    _this.icons = {};
    _this.icons.play = _react2.default.createElement('i', { className: _this.props.playIcon });
    _this.icons.playPreview = _react2.default.createElement('i', { className: _this.props.playIconPreview });
    _this.icons.pause = _react2.default.createElement('i', { className: _this.props.pauseIcon });
    _this.icons.volumeUp = _react2.default.createElement('i', { className: _this.props.volumenUpIcon });
    _this.icons.volumeDown = _react2.default.createElement('i', { className: _this.props.volumenDownIcon });
    _this.icons.mute = _react2.default.createElement('i', { className: _this.props.muteIcon });
    _this.icons.subtitles = _react2.default.createElement('i', { className: _this.props.subtitlesIcon });
    _this.icons.fullscreen = _react2.default.createElement('i', { className: _this.props.fullScreenIcon });
    _this.icons.nextVideo = _this.props.nextVideoIcon !== '' && _react2.default.createElement('i', { className: _this.props.nextVideoIcon });

    // store all public handler here, and return this api object to parent component;
    _this.api = {};
    var pubHandlers = ['togglePlay', 'play', 'pause', 'toggleMute', 'toggleSubtitle', 'setTime', 'getTime', 'fullscreen', 'volume', 'load', 'handleOverlay'];
    // save public handlers to api object
    pubHandlers.forEach(function (name) {
      _this['_' + name] = _this.api[name] = _this['_' + name].bind(_this);
    });
    // manually bind all handlers
    var handlers = ['metaDataLoaded', 'ended', 'timeupdate', 'durationchange', 'progress', 'canplay'];
    handlers.forEach(function (name) {
      return _this['_' + name] = _this['_' + name].bind(_this);
    });

    _this._handleOverlay = _this._handleOverlay.bind(_this);
    _this._hidePreroll = _this._hidePreroll.bind(_this);
    _this._showAndPlayPreroll = _this._showAndPlayPreroll.bind(_this);
    _this._toggleSubtitle = _this._toggleSubtitle.bind(_this);
    _this.customSubtitles = _this.customSubtitles.bind(_this);
    _this.handleContainerClick = _this.handleContainerClick.bind(_this);

    _this.pause = _this.pause.bind(_this);
    _this.play = _this.play.bind(_this);
    _this.mute = _this.mute.bind(_this);
    _this.resetProgessVideo = _this.resetProgessVideo.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ComLabVideo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onRef(this);

      this.$wraper = _reactDom2.default.findDOMNode(this);
      var $video = this.$video = this.api.$video = _reactDom2.default.findDOMNode(this.refs.video);

      //Para los subtitulos
      if ($video.textTracks && $video.textTracks.length) {
        var $customSubtitlesContainer = this.refs.customSubtitles;
        $video.textTracks[0].oncuechange = function (e) {
          if (this.activeCues) {
            var cue = this.activeCues[0];
            if (cue) {
              $customSubtitlesContainer.innerHTML = '';
              $customSubtitlesContainer.appendChild(cue.getCueAsHTML());
            }
          }
        };
      }

      if (this.props.subtitleOn) {
        this.$video.textTracks[this.state.activeSubtitle].mode = 'hidden';
        this.customSubtitles(true);
      }

      $video.addEventListener('loadedmetadata', this._metaDataLoaded);
      $video.addEventListener('ended', this._ended);
      // this update interval gap is too big make progressbar not snapy
      if (typeof this.props.timeUpdateCallback === 'function') {
        $video.addEventListener('timeupdate', this.props.timeUpdateCallback.bind(null, $video));
      }

      $video.addEventListener('progress', this._progress);
      $video.addEventListener('canplay', this._canplay);

      if (this.props.autoPlay && !this.seekbarUpdateTimer) this.seekbarUpdateInterval();

      //Habilitamos inlineVideo para iOS
      (0, _iphoneInlineVideo2.default)($video);
      //Pasamos al componente padre nuestra referencia si lo necesita
      if (typeof this.props.onRef === 'function') {
        this.props.onRef(this);
      }
    }

    /*Allow for loading video so, for example, a new src kicks in*/

  }, {
    key: '_load',
    value: function _load() {
      this.$video.load();
    }

    /**
     * after metaData Loaded we can get video dimentions and set width,height of video wraper;
     */

  }, {
    key: '_metaDataLoaded',
    value: function _metaDataLoaded(e) {
      //console.log('metadata loaded')
      if (this.props.metaDataLoaded && typeof this.props.metaDataLoaded == 'function') {
        this.props.metaDataLoaded(this.api);
      }

      // calculate width of seek bar and progress;
      this.$seekbarWraper = _reactDom2.default.findDOMNode(this.refs.seekbarWraper);
      this.setState({
        duration: (0, _DateTime.formatTime)(this.$video.duration)
      });
    }

    //Volver al principio del video cuando llega al final.

  }, {
    key: '_ended',
    value: function _ended(e) {
      //finaliza vídeo cambiamos de slider al siguiente
      this.props.handleNextSlider();
      this.setState({
        reStart: true,
        isPlaying: false
      });
    }
  }, {
    key: '_canplay',
    value: function _canplay(e) {
      //Incluimos esta función para lanzar play debido a que autoplay sobre el elemento html5 no está funcionando por razones desconocidas
      if (this.props.autoPlay) {
        this.$video.play();
      }
    }

    //Para que despues de avanzar el video este vuelva a reproducirse

  }, {
    key: 'seekbarUpdateInterval',
    value: function seekbarUpdateInterval() {
      this.seekbarUpdateTimer = setInterval(this._timeupdate, 80);
    }
  }, {
    key: '_setTimeFromBar',
    value: function _setTimeFromBar(e, isPercent) {
      var rect = e.currentTarget.getBoundingClientRect();
      var x = e.clientX - rect.left; //x position within the element.
      var percent = x * 100 / e.currentTarget.clientWidth;
      if (this.state.seekDisabled) return;
      if (isPercent && percent > 100) return;
      var time = isPercent ? percent * this.$video.duration / 100 : percent;
      this.$video.currentTime = time;
      this.setState({
        seekProgress: percent
      });
    }
  }, {
    key: '_setTime',
    value: function _setTime(time) {
      this.$video.currentTime = time;
    }
  }, {
    key: '_getTime',
    value: function _getTime() {
      return this.$video.currentTime;
    }

    // update seek bar width;

  }, {
    key: '_timeupdate',
    value: function _timeupdate(e) {

      var percent = this.$video.currentTime / this.$video.duration * 100;
      var newState = {
        seekProgress: percent,
        currentTime: (0, _DateTime.formatTime)(this.$video.currentTime)
      };
      if (this.$video.currentTime >= this.$video.duration) {
        newState.isPlaying = false;
      }
      if (this.count90 < 1 && percent > 90) {
        this.count90 = 1;
        // console.log("llegado al 90%");
        dataLayer.push({
          'event': 'STOP_90',
          'origen': 'web',
          'title': this.props.titleVideo,
          'segment': '',
          'cdnHost': '',
          'programTitle': this.props.programTitle,
          'temporada': 'no aplica',
          'capitulo': '',
          'duration': this.props.duration,
          'categoriaCat': 'video vod',
          'channel': 'LAB'
        });
      } else if (this.count75 < 1 && percent > 75) {
        this.count75 = 1;
        // console.log("llegado al 75%");
        dataLayer.push({
          'event': 'STOP_75',
          'origen': 'web',
          'title': this.props.titleVideo,
          'segment': '',
          'cdnHost': '',
          'programTitle': this.props.programTitle,
          'temporada': 'no aplica',
          'capitulo': '',
          'duration': this.props.duration,
          'categoriaCat': 'video vod',
          'channel': 'LAB'
        });
      } else if (this.count50 < 1 && percent > 50) {
        this.count50 = 1;
        // console.log("llegado al 50%");
        dataLayer.push({
          'event': 'STOP_50',
          'origen': 'web',
          'title': this.props.titleVideo,
          'segment': '',
          'cdnHost': '',
          'programTitle': this.props.programTitle,
          'temporada': 'no aplica',
          'capitulo': '',
          'duration': this.props.duration,
          'categoriaCat': 'video vod',
          'channel': 'LAB'
        });
      } else if (this.count25 < 1 && percent > 25) {
        this.count25 = 1;
        // console.log("llegado al 25%");
        dataLayer.push({
          'event': 'STOP_25',
          'origen': 'web',
          'title': this.props.titleVideo,
          'segment': '',
          'cdnHost': '',
          'programTitle': this.props.programTitle,
          'temporada': 'no aplica',
          'capitulo': '',
          'duration': this.props.duration,
          'categoriaCat': 'video vod',
          'channel': 'LAB'
        });
      }
      this.setState(newState);
    }
  }, {
    key: '_durationchange',
    value: function _durationchange() {}

    // loading progress bar (buffer bar)

  }, {
    key: '_progress',
    value: function _progress(e) {
      var buf = this.$video.buffered;
      var total = 0;
      for (var i = 0; i < buf.length; i++) {
        total += buf.end(i) - buf.start(i);
      }
      this.setState({
        loadedProgress: total / this.$video.duration * 100
      });
    }
  }, {
    key: 'resetProgessVideo',
    value: function resetProgessVideo() {
      this.$video.currentTime = 0;
    }
  }, {
    key: '_togglePlay',
    value: function _togglePlay(ev) {
      var _this2 = this;

      if (!this.props.toFull) {
        //se reproduce en su sitio

        if (!this.seekbarUpdateTimer) this.seekbarUpdateInterval();

        if (!this.state.isPlaying) {
          if (this.$video.currentTime >= this.$video.duration) this.$video.currentTime = 0;
          this.$video.play();
        } else {
          this.$video.pause();
        }

        this.setState({
          isPlaying: !this.state.isPlaying,
          reStart: false
        }, function () {
          if (_this2.props.preroll && !_this2.props.isMobile) {
            _this2._hidePreroll(ev);
          }

          _this2._handleOverlay();
        });
      } else {
        if (this.props.isMobile) {
          if (this.state.mobileStoped) {
            ev.currentTarget.parentElement.getElementsByTagName('video')[0].play();
          } else {
            ev.currentTarget.parentElement.getElementsByTagName('video')[0].pause();
          }
          this.setState({
            mobileStoped: !this.state.mobileStoped
          });
        } else {
          var newSrc = this.props.sources;
          this.props.handleShowMedia(newSrc);
        }
      }

      if (this.countPlay === 0) {
        //estadísticas primer play
        dataLayer.push({
          'event': 'PRIMER_PLAY',
          'origen': 'web',
          'title': this.props.titleVideo,
          'segment': '',
          'cdnHost': '',
          'programTitle': this.props.programTitle,
          'temporada': 'no aplica',
          'capitulo': '',
          'duration': this.props.duration,
          'categoriaCat': 'video vod',
          'channel': 'LAB'
        });
        this.countPlay = 1;
      }
    }
  }, {
    key: '_pause',
    value: function _pause() {
      if (!this.seekbarUpdateTimer) this.seekbarUpdateInterval();

      this.$video.pause();
      this.setState({
        isPlaying: false
      });
    }
  }, {
    key: 'pause',
    value: function pause() {
      if (!this.seekbarUpdateTimer) this.seekbarUpdateInterval();

      this.$video.pause();
      this.setState({
        isPlaying: false
      });
    }
  }, {
    key: '_play',
    value: function _play() {
      this.play();
    }
  }, {
    key: 'play',
    value: function play() {
      if (!this.seekbarUpdateTimer) this.seekbarUpdateInterval();
      /*  if (typeof this.props.notifyPlay === 'function')
        this.props.notifyPlay(this.$video.id);
      */
      if (this.$video.currentTime >= this.$video.duration) this.$video.currentTime = 0;
      this.$video.play();
      this.setState({
        isPlaying: true
      });
    }
  }, {
    key: 'mute',
    value: function mute(boolean) {
      this.$video.muted = boolean;
    }
  }, {
    key: '_toggleMute',
    value: function _toggleMute() {
      if (this.state.volume === 0) {
        this._volume(0.7);
      } else {
        this._volume(0);
      }
    }
  }, {
    key: '_muted',
    value: function _muted() {
      this._volume(0);
    }
  }, {
    key: '_fullscreen',
    value: function _fullscreen(e) {
      var apis = ['requestFullScreen', 'mozRequestFullScreen', 'webkitRequestFullscreen', 'msRequestFullscreen'];
      for (var i = 0; i < apis.length; i++) {
        if (this.$video[apis[i]]) return this.$video[apis[i]]();
      }
    }
  }, {
    key: '_volume',
    value: function _volume(val) {
      if (val <= 0) val = 0;
      if (val > 1) val = 1;
      this.$video.volume = val;
      var state = {
        volume: val,
        isMuted: val <= 0.05 ? true : false
      };
      this.setState(state);
    }
  }, {
    key: '_toggleSubtitle',
    value: function _toggleSubtitle() {
      var state = {};
      if (this.$video.textTracks[this.state.activeSubtitle]) {
        if (this.$video.textTracks[this.state.activeSubtitle].mode === 'disabled') {
          this.customSubtitles(true);
          this.$video.textTracks[this.state.activeSubtitle].mode = 'hidden';
          state.isSubtitled = true;
        } else {
          this.customSubtitles(false);
          this.$video.textTracks[this.state.activeSubtitle].mode = 'disabled';
          state.isSubtitled = false;
        }
      }
      this.setState(state);
    }
  }, {
    key: '_setSubtitle',
    value: function _setSubtitle(index) {
      if (this.$video.textTracks[this.state.activeSubtitle]) this.$video.textTracks[this.state.activeSubtitle].mode = 'disabled';
      this.$video.textTracks[index].mode = 'showing';
      this.setState({
        activeSubtitle: index
      });
    }
  }, {
    key: '$getSubtitleTracksMenu',
    value: function $getSubtitleTracksMenu() {
      var _this3 = this;

      var $menuItems = [];
      if (!this.$video || this.$video.textTracks.length <= 0) return $menuItems;

      var _loop = function _loop(i) {
        var track = _this3.$video.textTracks[i];
        $menuItems.push(_react2.default.createElement(
          'li',
          { key: i },
          _react2.default.createElement(
            'button',
            { onClick: function onClick(e) {
                return _this3._setSubtitle(i);
              } },
            track.label
          )
        ));
      };

      for (var i = 0; i < this.$video.textTracks.length; i++) {
        _loop(i);
      }
      this.subTitleMenu = _react2.default.createElement(
        'span',
        { className: 'r5-subtitle' },
        _react2.default.createElement(
          'button',
          null,
          this.icons.subtitles
        ),
        _react2.default.createElement(
          'ul',
          { className: 'r5-subtitle-menu' },
          $menuItems
        )
      );
      return this.subTitleMenu;
    }

    // generate subtitle tracks: <track >

  }, {
    key: '$getSubtitleTracks',
    value: function $getSubtitleTracks(subtitles, subtitleOn) {
      if (!Array.isArray(subtitles)) return '';
      var $tracks = [];
      for (var i = 0; i < subtitles.length; i++) {
        var track = subtitles[i];

        if (this.protocol == 'http:') {
          var arr = this.context.baseUrl.split('');
          var arr1 = arr.slice(0, 4);
          var arr2 = arr.slice(5, arr.length);
          arr = arr1.join('') + arr2.join('');
          $tracks.push(_react2.default.createElement('track', {
            src: arr + track.src,
            kind: 'subtitles',
            srcLang: track.lang,
            label: track.label,
            key: i,
            'default': subtitleOn
          }));
        } else {
          $tracks.push(_react2.default.createElement('track', {
            src: this.context.baseUrl + track.src,
            kind: 'subtitles',
            srcLang: track.lang,
            label: track.label,
            key: i,
            'default': subtitleOn
          }));
        }
      }
      return $tracks;
    }

    //Función que recibe un array con un src o un objeto indicando diferentes src de diferentes tipos
    //Ej: src='/media/examples/flower.webm' type='video/webm' || '/media/examples/flower.mp4' 'video/mp4'

  }, {
    key: '$getSource',
    value: function $getSource(sources) {
      if (!Array.isArray(sources)) return [];
      var $sources = [];
      for (var i = 0; i < sources.length; i++) {
        var src = void 0,
            type = void 0;
        if ((0, _typeof3.default)(sources[i]) === 'object') {
          src = sources[i].src;
          type = sources[i].type;
        } else {
          src = sources[i];
          type = 'video/' + _path2.default.extname(src).substr(1).split('?')[0];
        }
        $sources.push(_react2.default.createElement('source', { src: src, type: type, key: i }));
      }
      return $sources;
    }
  }, {
    key: '_hidePreroll',
    value: function _hidePreroll(ev) {
      this.$videoPreroll.pause();
      this.$prerollContainer.classList.add('hide');

      if (this.props.callback) {
        this.props.callback();
      }

      this._handleOverlay();
    }
  }, {
    key: '_handleOverlay',
    value: function _handleOverlay() {
      var overlay = _reactDom2.default.findDOMNode(this.refs.overlay);
      if (!this.state.isPlaying) {
        overlay.classList.add('toFront');
      } else {
        overlay.classList.remove('toFront');
      }
    }
  }, {
    key: '_showAndPlayPreroll',
    value: function _showAndPlayPreroll() {
      if (this.$video.currentTime === 0) {
        var elementoBack = _reactDom2.default.findDOMNode(this.refs.overlay);
        elementoBack.classList.remove('toFront');

        this.$videoPreroll.play();
        this.$prerollContainer.classList.remove('hide');
      }
    }
  }, {
    key: 'customSubtitles',
    value: function customSubtitles(subtitleOn) {
      var $video = this.refs.video;

      if (subtitleOn) {
        if (!$video.textTracks) return;
        this.setState({
          customSubtitlesShow: true
        });
      } else {
        this.setState({
          customSubtitlesShow: false
        });
      }
    }
  }, {
    key: 'handleContainerClick',
    value: function handleContainerClick(e) {
      this._togglePlay(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          subtitles = _props.subtitles,
          subtitleOn = _props.subtitleOn,
          loop = _props.loop,
          autoPlay = _props.autoPlay,
          preload = _props.preload,
          sources = _props.sources,
          controlPanelStyle = _props.controlPanelStyle,
          autoHideControls = _props.autoHideControls,
          dataStatsId = _props.dataStatsId,
          id = _props.id;
      //html5 video options

      var options = {
        loop: loop,
        autoPlay: autoPlay,
        preload: preload
      };

      var wraperStyle = {},
          contentWraperStyle = {};
      var $video = this.$video || {};
      var duration = (0, _DateTime.formatTime)($video.duration);

      var vWidth = this.props.width || $video.videoWidth || $video.clientWidth;

      var vHeight = this.props.height || $video.videoHeight || $video.clientHeight;
      options.width = vWidth;
      options.height = vHeight;
      wraperStyle.width = vWidth + 'px';
      wraperStyle.height = vHeight + 'px';
      if (this.props.controlPanelStyle == 'fixed') wraperStyle.height = vHeight + 50 + 'px';

      var wraperClass = 'r5-wraper ' + this.props.layout;
      var controlsClass = 'r5-controls r5-controls--' + controlPanelStyle + ' ' + (autoHideControls ? 'r5-auto-hide' : '') + ' ';
      if (!this.props.controls) controlsClass = 'r5-controls-hidden';
      var subsClass = 'r5-subtitle';
      if (!this.state.isSubtitled) subsClass += ' r5-subs-hidden';

      var customSubtitlesClass = (0, _classnames2.default)({
        customSubtitles: true,
        show: this.state.customSubtitlesShow
      });
      var portada = (0, _classnames2.default)({
        'r5-overlay': true,
        toFront: true,
        playing: this.state.reStart
      });
      return _react2.default.createElement(
        'div',
        { className: 'alreadyPlayed' },
        _react2.default.createElement(
          'div',
          { className: wraperClass, ref: 'videoWrapper' },
          this.props.canClose && _react2.default.createElement('span', { className: 'icon-circle-close' }),
          _react2.default.createElement(
            'video',
            (0, _extends3.default)({
              ref: 'video'
            }, options, {
              playsInline: true,
              crossOrigin: 'anonymous',
              'data-stats-id': dataStatsId,
              id: id && id,
              onClick: this._togglePlay,
              muted: true,
              autoPlay: true,
              preload: 'auto'
            }),
            this.$getSource(sources),
            subtitles && subtitles.length > 0 && this.$getSubtitleTracks(subtitles, subtitleOn)
          ),
          this.props.overlay && _react2.default.createElement(
            'div',
            {
              ref: 'overlay',
              className: portada,
              onClick: this._togglePlay
            },
            _react2.default.createElement(
              'button',
              { className: 'specialCircledPlay' },
              this.icons.playPreview
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'r5-content', style: contentWraperStyle },
            this.props.children
          ),
          _react2.default.createElement(
            'div',
            { className: controlsClass },
            _react2.default.createElement(
              'div',
              { className: 'r5-panel' },
              _react2.default.createElement(
                'button',
                { className: 'r5-play custom-pos specialCircledPlay', onClick: this._togglePlay },
                this.state.isPlaying ? this.icons.pause : this.icons.play
              ),
              this.props.nextVideoIcon !== '' && _react2.default.createElement(
                'button',
                {
                  className: 'r5-custom custom-pos',
                  onClick: this.props.nextVideoAction
                },
                this.icons.nextVideo
              ),
              _react2.default.createElement(
                'span',
                { className: 'r5-timecode' },
                this.state.currentTime
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'r5-seekbar-wraper',
                  ref: 'seekbarWraper',
                  onClick: function onClick(e) {
                    return _this4._setTimeFromBar(e, true);
                  }
                },
                _react2.default.createElement('div', {
                  className: 'r5-seekbar-loaded',
                  ref: 'seekbar',
                  style: { width: this.state.loadedProgress + '%' }
                }),
                _react2.default.createElement('div', {
                  className: 'r5-seekbar',
                  ref: 'loadedbar',
                  style: { width: this.state.seekProgress + '%' }
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'r5-controls-wraper' },
                _react2.default.createElement(
                  'span',
                  { className: 'r5-duration' },
                  duration
                ),
                _react2.default.createElement(
                  'div',
                  { className: subsClass },
                  _react2.default.createElement(
                    'button',
                    { className: 'custom-pos', onClick: this._toggleSubtitle },
                    this.props.icons.subtitles || this.icons.subtitles
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'r5-volume' },
                  _react2.default.createElement(
                    'button',
                    { className: 'custom-pos', onClick: this._toggleMute },
                    this.state.isMuted ? this.props.icons.mute || this.icons.mute : this.props.icons.sound || (this.state.volume > 0.7 ? this.icons.volumeUp : this.icons.volumeDown)
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'r5-volume-inner',
                      style: { width: '6px', height: '80px' }
                    },
                    _react2.default.createElement('div', {
                      className: 'r5-volume-bar',
                      style: { height: this.state.volume * 100 + '%' }
                    }),
                    _react2.default.createElement('input', {
                      orient: 'vertical',
                      type: 'range',
                      min: '0',
                      max: '1',
                      step: '0.05',
                      value: this.state.volume,
                      onChange: function onChange(e) {
                        return _this4._volume(e.target.value);
                      }
                    })
                  )
                ),
                !this.props.isApple && _react2.default.createElement(
                  'button',
                  { className: 'r5-fullscreen', onClick: this._fullscreen },
                  this.icons.fullscreen
                )
              )
            )
          )
        ),
        _react2.default.createElement('div', { ref: 'customSubtitles', className: customSubtitlesClass })
      );
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);

      var $video = this.$video = this.api.$video = _reactDom2.default.findDOMNode(this.refs.video);
      $video.removeEventListener('loadedmetadata', this._metaDataLoaded);
      $video.removeEventListener('ended', this._ended);
      $video.removeEventListener('progress', this._progress);

      if (this.props.preroll && !this.props.isMobile) {
        this.$wraper.removeEventListener('mouseenter', this._showAndPlayPreroll);
        this.$wraper.removeEventListener('mouseleave', this._hidePreroll);
      }

      if (this.seekbarUpdateTimer) clearInterval(this.seekbarUpdateTimer);
    }
  }]);
  return ComLabVideo;
}(_react.Component), _class.contextTypes = {
  baseUrl: _propTypes2.default.string.isRequired
}, _temp);
exports.default = ComLabVideo;


ComLabVideo.propTypes = {
  // callbacks
  metaDataLoaded: _propTypes2.default.func, // video's meta data loaded, return video element
  ended: _propTypes2.default.func,

  // properties
  sources: _propTypes2.default.array,
  subtitles: _propTypes2.default.array, // [{src:'foo.vtt', label:'English',srclan:'en' }]
  autoPlay: _propTypes2.default.bool,
  controls: _propTypes2.default.bool,
  autoHideControls: _propTypes2.default.bool,
  controlPanelStyle: _propTypes2.default.oneOf(['overlay', 'fixed']), // overlay, fixed
  preload: _propTypes2.default.oneOf(['auto', 'none', 'metadata']),
  loop: _propTypes2.default.bool,
  mute: _propTypes2.default.bool,
  icons: _propTypes2.default.object,
  layout: _propTypes2.default.string,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  volume: _propTypes2.default.number,
  activeSubtitle: _propTypes2.default.number,
  seekDisabled: _propTypes2.default.bool,
  isSubtitled: _propTypes2.default.bool
};

ComLabVideo.defaultProps = {
  autoPlay: false,
  loop: false,
  controls: true,
  autoHideControls: false,
  volume: 1.0,
  mute: false,
  layout: '',
  icons: {},
  controlPanelStyle: 'overlay',
  preload: 'auto',
  seekDisabled: false
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ComLabVideo/ComLabVideo.jsx
// module id = 693
// module chunks = 0